import http from '@/core/http'
// eslint-disable-next-line
import { map } from 'lodash'
// eslint-disable-next-line
// import moment from 'moment'

const url = 'transacoes'

const state = {
  itens: [],
  totalItens: 0,
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, { params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  clearItens: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LIMPAR_ITEM' (state) {
    state.itens = [],
    state.totalItens = 0
  },
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
}

export default { namespaced: true, state, actions, mutations, getters }